<mat-expansion-panel expanded="true" class="mt-3">
  <mat-expansion-panel-header>
    <mat-panel-title class="mat-panel-title">
      {{ "title.search_info" | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form (ngSubmit)="page = 0; featureStatus ? searchContract() : ''"
        [formGroup]="filterForm"
        class="pb-3">
    <div class="row">
      <!--      Tên hoặc mã hợp đồng-->
      <div class="col-lg-3 col-md-6">
        <mat-form-field class="w-100">
          <input type="text" matInput formControlName="docCode"
                 [placeholder]="'search_form.doc_name_or_code' | translate"
                 (focusout)="filterForm.controls.docCode.setValue(filterForm.controls.docCode.value.trim())"
                 >
          <button mat-button *ngIf="filterForm.controls.docCode.value"
                  type="button" matSuffix mat-icon-button
                  aria-label="Clear"
                  (click)="filterForm.controls.docCode.reset('')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!--      Hợp đồng cha-->
      <div class="col-lg-3 col-md-6">
        <mat-form-field class="w-100">
          <input type="text" matInput formControlName="docParent"
                 [placeholder]="'form.doc_reference' | translate"
                 (focusout)="filterForm.controls.docParent.setValue(filterForm.controls.docParent.value.trim())"
                 >
          <button mat-button *ngIf="filterForm.controls.docParent.value"
                  type="button" matSuffix mat-icon-button
                  aria-label="Clear"
                  (click)="filterForm.controls.docParent.reset('')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!--      Loại hợp đồng-->
      <div class="col-lg-3 col-md-6">
        <mat-form-field class="w-100">
          <mat-label>{{ 'form.digital_contract.document_type' | translate }}</mat-label>
          <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)"
                      (selectionChange)="checkFocus = false"
                      (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)"
                      formControlName="docType"
          >
            <mat-option>
              <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                     [placeholderLabel]="'search_form.search' | translate"
                                     [formControl]="serviceTypeCtrl">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let serviceType of filteredServiceTypes | async" [value]="serviceType.id"
                        (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
              {{serviceType.name}}
            </mat-option>
          </mat-select>
          <button mat-button *ngIf="filterForm.controls.docType.value"
                  type="button" matSuffix mat-icon-button
                  aria-label="Clear"
                  (click)="filterForm.controls.docType.reset('')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="col-lg-3 col-md-6">
        <mat-form-field class="w-100">
          <input type="text" matInput formControlName="docCodeParent"
                 [placeholder]="'search_form.doc_name_or_code_parent' | translate"
                 (focusout)="filterForm.controls.docCodeParent.setValue(filterForm.controls.docCodeParent.value.trim())"
          >
          <button mat-button *ngIf="filterForm.controls.docCodeParent.value"
                  type="button" matSuffix mat-icon-button
                  aria-label="Clear"
                  (click)="filterForm.controls.docCodeParent.reset('')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!--      Ngày hiệu lực từ ngày đến ngày-->
      <div class="d-flex w-50">
        <div class="col-6">
          <mat-form-field class="w-100">
            <input matInput [matDatepicker]="picker1"
                   [placeholder]="'search_form.effective_time_from' | translate"
                   [max]="filterForm.controls.effectiveTo.value"
                   formControlName="effectiveFrom"
                   (focusout)="focusOut('effectiveFrom')"
                   (input)="effectiveField = 'effectiveFrom'"
            >
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <button mat-button *ngIf="filterForm.controls.effectiveFrom.value"
                    type="button" matSuffix mat-icon-button
                    aria-label="Clear"
                    (click)="filterForm.controls.effectiveFrom.reset()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error
              *ngIf="filterForm.controls.effectiveFrom.hasError('matDatepickerMax') && effectiveField === 'effectiveFrom'">
              {{ "digital_contract.error.effectiveDateFrom_validate" | translate }}
            </mat-error>
            <mat-error *ngIf="filterForm.controls.effectiveFrom.hasError('matDatepickerParse')">
              {{ "digital_contract.error.date_pattern" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100">
            <input matInput [matDatepicker]="picker2"
                   [placeholder]="'search_form.effective_time_to' | translate"
                   [min]="filterForm.controls.effectiveFrom.value"
                   formControlName="effectiveTo"
                   (focusout)="focusOut('effectiveTo')"
                   (input)="effectiveField = 'effectiveTo'"
            >
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
            <button mat-button *ngIf="filterForm.controls.effectiveTo.value"
                    type="button" matSuffix mat-icon-button
                    aria-label="Clear"
                    (click)="filterForm.controls.effectiveTo.reset()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error
              *ngIf="filterForm.controls.effectiveTo.hasError('matDatepickerMin') && effectiveField === 'effectiveTo'">
              {{ "digital_contract.error.effectiveDateTo_validate" | translate }}
            </mat-error>
            <mat-error *ngIf="filterForm.controls.effectiveTo.hasError('matDatepickerParse')">
              {{ "digital_contract.error.date_pattern" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!--      Ngày hết hiệu lực-->
      <div class="d-flex w-50">
        <div class="col-6">
          <mat-form-field class="w-100">
            <input matInput [matDatepicker]="picker3"
                   [placeholder]="'search_form.expire_time_from' | translate"
                   [max]="filterForm.controls.expireTimeTo.value"
                   formControlName="expireTimeFrom"
                   (focusout)="focusOut('expireTimeFrom')"
                   (input)="expiredField = 'expireTimeFrom'"
            >
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker #picker3></mat-datepicker>
            <button mat-button *ngIf="filterForm.controls.expireTimeFrom.value"
                    type="button" matSuffix mat-icon-button
                    aria-label="Clear"
                    (click)="filterForm.controls.expireTimeFrom.reset()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error
              *ngIf="filterForm.controls.expireTimeFrom.hasError('matDatepickerMax') && expiredField === 'expireTimeFrom'">
              {{ "digital_contract.error.expiredDateFrom_validate" | translate }}
            </mat-error>
            <mat-error *ngIf="filterForm.controls.expireTimeFrom.hasError('matDatepickerParse')">
              {{ "digital_contract.error.date_pattern" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100">
            <input matInput [matDatepicker]="picker4"
                   [placeholder]="'search_form.expire_time_to' | translate"
                   [min]="filterForm.controls.expireTimeFrom.value"
                   formControlName="expireTimeTo"
                   (focusout)="focusOut('expireTimeTo')"
                   (input)="expiredField = 'expireTimeTo'"
            >
            <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
            <mat-datepicker #picker4></mat-datepicker>
            <button mat-button *ngIf="filterForm.controls.expireTimeTo.value"
                    type="button" matSuffix mat-icon-button
                    aria-label="Clear"
                    (click)="filterForm.controls.expireTimeTo.reset()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error
              *ngIf="filterForm.controls.expireTimeTo.hasError('matDatepickerMin') && expiredField === 'expireTimeTo'">
              {{ "digital_contract.error.expiredDateTo_validate" | translate }}
            </mat-error>
            <mat-error *ngIf="filterForm.controls.expireTimeTo.hasError('matDatepickerParse')">
              {{ "digital_contract.error.date_pattern" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <mat-form-field class="w-100">
          <mat-label>{{'search_form.status' | translate}}</mat-label>
          <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                      (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status" name="status"
                      formControlName="status">
            <mat-option [value]="''" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
              {{'form.select_all' | translate}}</mat-option>
            <mat-option [value]="1"
                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
              {{'search_form.draft' | translate}}</mat-option>
            <mat-option [value]="8"
                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
              {{'contract_share_partner.issued' | translate}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="d-flex col-12 justify-content-end align-items-center">
        <span style="margin-right: 10px;">{{ 'search_form.null_expired_date' | translate }}</span>
        <mat-checkbox formControlName="nullExpiredDate" (change)="checkboxNull()" class="null-expired-date"></mat-checkbox>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-lg-12 d-flex justify-content-center">
        <button mat-stroked-button color="primary" type="submit" appTrackEvent="w.btn.hdsohoatoiquanly.tim_kiem"
                (click)="page = 0; contractService.isSearch.next(true)"
                [disabled]="!filterForm.valid || !featureStatus || isTableLoading" [ngClass]="{'active_document': !featureStatus}">
          <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
          {{'enterprise_contract.buttons.search' | translate}}
        </button>
      </div>
    </div>

  </form>
</mat-expansion-panel>
